<template>
  <div
    class="lp-divider"
    :class="{
      'lp-divider-h': !vertical,
      'lp-divider-v': vertical,
      [`bg-${color}`]: color,
      [`xmt-${topMargin}`]: !disableTopMargin && topMargin && !vertical,
      [`xmb-${bottomMargin}`]:
        !disableBottomMargin && bottomMargin && !vertical,
    }"
    role="separator"
  />
</template>

<script setup lang="ts">
import { SpacingType } from '@/models/enums/Spacing'

defineOptions({
  name: 'lp-divider',
})
interface Props {
  disableTopMargin?: boolean
  disableBottomMargin?: boolean
  topMargin?: SpacingType
  bottomMargin?: SpacingType
  vertical?: boolean
  color?: string
}
withDefaults(defineProps<Props>(), {
  disableTopMargin: false,
  disableBottomMargin: false,
  topMargin: '3',
  bottomMargin: '3',
  vertical: false,
  color: 'black-20',
})
</script>
